/**
 * Central configuration for all content sections
 * 
 * This file is the SINGLE SOURCE OF TRUTH for all content sections.
 * When adding/removing sections:
 * 1. Update this file
 * 2. All UI components (App.js, WelcomeGuide.js) will auto-update
 * 
 * IMPORTANT: Keep this in sync with backend section keys in server.py
 */

export const SECTIONS_CONFIG = {
  // ═══════════════════════════════════════════════════════════
  // TIME-BASED CATEGORIES (FIRST!)
  // ═══════════════════════════════════════════════════════════
  morning: { 
    emoji: "☀️", 
    title: "ΠΡΩΙΝΟ",
    subtitle: "Περιεχόμενο για 06:00-10:00",
    description: "Ανθρώπινες στιγμές, Διλήμματα, Εξομολογήσεις, Κοινές ενοχλήσεις"
  },
  afternoon: { 
    emoji: "🌅", 
    title: "ΑΠΟΓΕΥΜΑ / DRIVE TIME",
    subtitle: "Περιεχόμενο για 16:00-19:00",
    description: "Μετάβαση δουλειά→σπίτι, Εκτόνωση, Κίνηση, Weekend Countdown"
  },
  evening: { 
    emoji: "🌙", 
    title: "ΒΡΑΔΥ",
    subtitle: "Περιεχόμενο για 19:00-24:00",
    description: "Κρυφά διαμάντια, Ιστορίες καλλιτεχνών, Acoustic versions, Νοσταλγία"
  },
  weekend: { 
    emoji: "🎉", 
    title: "ΣΑΒΒΑΤΟΚΥΡΙΑΚΟ",
    subtitle: "Weekend Vibes",
    description: "Ιδέες για έξοδο, Οδηγός πόλης, Νέες κυκλοφορίες, Events, Sunday Chill"
  },
  
  // Core sections
  zodiac: { emoji: "♈", title: "Ζώδια της Ημέρας" },
  sex_relationships: { emoji: "💑", title: "Sex & Relationships" },
  for_women_only: { emoji: "💖", title: "Για γυναίκες μόνο" },
  weird_news: { emoji: "🤪", title: "Weird News" },
  bad_recipes: { emoji: "🍳", title: "Bad Recipes" },
  birthdays: { emoji: "🎂", title: "Birthdays" },
  strange_weird: { emoji: "👽", title: "Strange & Weird" },
  world_days: { emoji: "🌍", title: "World Days" },
  radio_contest: { emoji: "🎯", title: "Radio Contest" },
  good_news: { emoji: "✨", title: "Good News" },
  research_says: { emoji: "🔬", title: "Research Says" },
  
  // New sections (added 2025-11)
  health_wellness: { emoji: "💊", title: "Υγεία & Ευεξία" },
  personal_finance: { emoji: "💰", title: "Οικονομικά & Χρήματα" },
  games_riddles: { emoji: "🧩", title: "Παιχνίδια & Γρίφοι" },
  tech_innovation: { emoji: "🚀", title: "Τεχνολογία & Καινοτομία" },
  small_secrets: { emoji: "🤫", title: "Μικρά Μυστικά" },
  
  // Interactive sections
  one_word_game: { emoji: "🎙️", title: "One Word Game" },
  male_vs_female: { emoji: "⚔️", title: "Male vs Female" },
  truth_or_myth: { emoji: "🔍", title: "Αλήθεια ή Μύθος" },
  yes_or_no: { emoji: "🤷", title: "Το Ναι ή το Όχι" },
  real_or_epic_lie: { emoji: "🤥", title: "Αληθινό ή Επικό Ψέμα" },
  man_says_woman_responds: { emoji: "💬", title: "Ο άντρας λέει – η γυναίκα απαντά" },
  what_drives_me_crazy: { emoji: "😤", title: "Αυτό που με τρελαίνει" },
  debate_of_the_day: { emoji: "⚖️", title: "Το Debate της Ημέρας" },
  guess_the_profession: { emoji: "🎯", title: "Μάντεψε το Επάγγελμα" },
  guess_song_from_lyric: { emoji: "🎶", title: "Μάντεψε το Τραγούδι" },
  todays_confession: { emoji: "🤫", title: "Η Ομολογία της Ημέρας" },
  fastest_wins_contest: { emoji: "🏃", title: "Fastest Wins Contest" },
  greek_habits_never_die: { emoji: "🇬🇷", title: "Greek Habits Never Die" },
  
  // Stats & Trends
  daily_record: { emoji: "🏆", title: "Daily Record" },
  would_you_rather: { emoji: "🤔", title: "Would You Rather" },
  music_lifestyle: { emoji: "🎵", title: "Music & Lifestyle" },
  sports_news: { emoji: "⚽", title: "Sports News" },
  funny_habits: { emoji: "😄", title: "Funny Habits" },
  trends: { emoji: "📈", title: "Trends" },
  weather: { emoji: "🌤️", title: "Weather" },
  on_this_day_charts: { emoji: "📅", title: "Σαν Σήμερα Charts" },  // ΕΠΑΝΑΦΟΡΑ
  
  // Charts & Media
  shazam_chart_greece: { emoji: "🎵", title: "Apple Music Greece" },
  radio_top_songs: { emoji: "📻", title: "Radio Top Songs" },
  youtube_trending_greece: { emoji: "📹", title: "YouTube Trending Greece" },
  // spotify_chart_greece: REMOVED - scraper not working in production
  
  // Information
  today_in_music_history: { emoji: "🎸", title: "Today in Music History" }
};

/**
 * Get all section keys (for iteration)
 */
export const getAllSectionKeys = () => Object.keys(SECTIONS_CONFIG);

/**
 * Get total number of sections
 */
export const getTotalSections = () => getAllSectionKeys().length;

/**
 * Get section by key
 */
export const getSection = (key) => SECTIONS_CONFIG[key];

/**
 * Check if section exists
 */
export const sectionExists = (key) => key in SECTIONS_CONFIG;
